module.exports = __webpack_public_path__ + "img/41.12998b08.png";